import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <SliderJoint3D>: a Node3D group that draws Godot's slider travel and one circle around X per
 * resolved body for every node, faint while unselected (ADR-0056): the circle follows the angular
 * limits and looks from the joint at its body (`joint_3d_gizmo_plugin.cpp:503-560`).
 */
import { useCallback, useMemo } from 'react';
import { Node3D } from '../../../base/node3d/Component';
import { PluginGizmo } from '../../../../r3f/gizmo/PluginGizmo';
import { JointBodyLines } from '../joint3d/JointBodyLines';
import { JointGizmoLines } from '../joint3d/JointGizmoLines';
import { sliderBodySegments, sliderJointSegments } from '../joint3d/jointGizmoDrawer';
import { useJointBodies } from '../joint3d/useJointBodies';
import { drawnLimits } from './types';
function SliderGizmo({ properties }) {
    const bodies = useJointBodies(properties);
    const { linearLower, linearUpper, angularLower, angularUpper } = drawnLimits(properties);
    const travel = useMemo(() => sliderJointSegments(linearLower, linearUpper), [linearLower, linearUpper]);
    const segmentsFor = useCallback((joint, body, part) => sliderBodySegments(joint, body, part, angularLower, angularUpper), [angularLower, angularUpper]);
    if (bodies === null)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(JointGizmoLines, { part: "joint", positions: travel }), _jsx(JointBodyLines, { bodies: bodies, segmentsFor: segmentsFor })] }));
}
export function SliderJoint3D({ node, children }) {
    return (_jsxs(Node3D, { node: node, children: [_jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(SliderGizmo, { properties: node.properties }) }), children] }));
}
//# sourceMappingURL=Component.js.map